module.exports = __webpack_public_path__ + "static/media/jamm-title.dd671f4a.png";